<aslib-title></aslib-title>

<form novalidate [formGroup]='formGeraroValorMensalDistribuir'>
  <div class="form-group row">
    <label for="" class="col-md-3 text-right">Mês de Referência:</label>
    <div class="controls col-md-2">
      <input type="text" appMonthYear placeholder="MM/YYYY" [(ngModel)]="filtro.anoReferencia" required formControlName="dataReferenciaDistribuicao" class="form-control" />
    </div>
  </div>
  <div class="form-group row">
    <label for="" class="col-md-3 text-right">Municipios:</label>
    <div class="controls col-md-3">
      <search-dropdown
                        id="municipios"
                        [items]="municipiosVig"
                        [label]="'Municipio'"
                        [uid]="'CodigoMunicipio'"                          
                        [(ngModel)]="filtro.codMunicipio"
                        [defaultLabel] = "'Todos'"
                        [ngModelOptions]="{standalone: true}"                                        
                    >
                    </search-dropdown>
    </div>
  </div>

  <div class="form-group row">
    <div class="controls col-md-4 offset-md-3">
      <button type="submit" class="btn btn-primary"   (click)="consulta()" >
        <aslib-icon type="1" icon="fa fa-search"></aslib-icon>Filtrar</button>
    <button type="submit" class="btn btn-primary" (click)="limparConsulta()" >
        <aslib-icon type="1" icon="fa fa-refresh"></aslib-icon>Limpar</button>
    </div>
  </div>

  <div class="form-group row" >
    <div class="col-md-12 text-right">
      <button type="button" class="btn btn-primary" (click)="irPraAdicionar()"  >
        <aslib-icon type="1" icon="fa fa-plus"></aslib-icon>Gerar Valor Mensal
      </button>
    </div>
  </div>

<div class="form-group row mb-5" *ngIf="exibirGrid" >
  
  <aslib-grid id="as-grid" class="col-md-12" [(dataset)]="municipiosGrid" [pagination]="false" [regPerPageVisible]="false" [limit]="municipiosGrid.length" >
        
    <aslib-grid-column [property]="'Municipio'" [header]="'Município'" [width]="100" [sortable]="false" >
      <ng-template #AslibGridCell let-item="item">
        <span [class.summary-row]="item.__summary">{{ item.__summary ? 'Total:' : item.Municipio }}</span>
      </ng-template> 
    </aslib-grid-column>
    <aslib-grid-column [property]="'indiceIPM'" [header]="'Índice IPM'" [width]="40" [sortable]="false">
      <ng-template #AslibGridCell let-item="item">
        <ng-container *ngIf="!item.__summary; else linhaTotal0">
          {{item.indiceIPM | number:'1.6-6'}}
        </ng-container>
        <ng-template #linhaTotal0>
          <span class="cell-hidden-on-summary"></span>
        </ng-template>
      </ng-template>
    </aslib-grid-column>
    <aslib-grid-column [property]="'mesReferencia'" [header]="'Mês/Ano Referência'" [width]="40" [sortable]="false">
      <ng-template #AslibGridCell let-item="item">
        <ng-container *ngIf="!item.__summary; else totalMesAno">
          {{item.mesReferencia}}
        </ng-container>
        <ng-template #totalMesAno>
          <span class="cell-hidden-on-summary"></span>
        </ng-template>
      </ng-template>
    </aslib-grid-column>

    <aslib-grid-column [property]="'valorDistribuido'"  [width]="60" [header]="'Valor Distribuído'"  [sortable]="false">
      <ng-template #AslibGridCell let-item="item">
        <ng-container *ngIf="!item.__summary; else total1">
          {{item.valorDistribuido | currency:'BRL':'symbol':'1.4-4':'pt-BR'}}
        </ng-container>
        <ng-template #total1>
          <strong class="total-cell">{{ item.valor1 | currency:'BRL':'symbol':'1.4-4':'pt-BR' }}</strong>
        </ng-template>
      </ng-template>
    </aslib-grid-column>

    
    <aslib-grid-column [property]="'valorArredondado'"  [width]="50" [header]="'Valor Arredondado'"  [sortable]="false">
      <ng-template #AslibGridCell let-item="item">
        <ng-container *ngIf="!item.__summary; else total2">
          {{item.valorArredondado | currency:'BRL'}}
        </ng-container>
        <ng-template #total2>
          <strong class="total-cell">{{ item.valor2 | currency:'BRL' }}</strong>
        </ng-template>
      </ng-template>
    </aslib-grid-column>
    <aslib-grid-column [property]="'active'" [header]="'Ações'" [width]="40" [sortable]="false" [resizable]="true"
      class="text-center">
      <ng-template #AslibGridHeader let-item="item"><span>Ações</span></ng-template>
      <ng-template #AslibGridCell let-item="item">
        <!--<button type="button" class="btn btn-sm btn-primary" title="Editar" [hide]="item.__summary"
          ascas-data="Editar item" (click)="editar(detalheLiq,item)">
          <aslib-icon type="1" icon="fa fa-pencil"></aslib-icon>
        </button>-->
      </ng-template>
    </aslib-grid-column>
  </aslib-grid>
</div>
  <div class="form-group row"  *ngIf="exibirGrid">
    <div class="col-md-12">
      <button type="submit" class="btn btn-primary" (click)="salvarValorMensalDistribuicao(modalMensagem)"  >
        <aslib-icon type="1" icon="fa fa-save"></aslib-icon>Excel
      </button>
      <!--<button type="submit" class="btn btn-primary" (click)="excluir(modalMensagem)"  >
        <aslib-icon type="1" icon="fa fa-trash"></aslib-icon>Excluir
      </button>-->
    </div>
  </div>

</form>
<div class="card-block">  
  <div class="row">
    <div class="col-md-10">
    <ng-template #detalheLiq>
      <sarf-detalhe-valor-mensal [muncipioSelecionado]="itemSelecionado"></sarf-detalhe-valor-mensal>
    </ng-template>
    </div>
  </div>
<aslib-modal #modalMensagem></aslib-modal>
  </div>

  <style>

      .summary-row,
      .summary-row * {
        font-weight: 600;
      }

 
/* Linha que contém o marcador 'summary-row' */
:host ::ng-deep #as-grid tbody tr:has(.summary-row) td {
  background: #c3c3c3;
}

/* Apagar apenas as colunas intermediárias (Índice IPM, Mês/Ano, Ações) nessa linha */
:host ::ng-deep #as-grid tbody tr:has(.summary-row) td.column-indiceIPM,
:host ::ng-deep #as-grid tbody tr:has(.summary-row) td.column-mesReferencia,
:host ::ng-deep #as-grid tbody tr:has(.summary-row) td.data-column.text-center {
  border-color: #c3c3c3 !important;
  border-bottom-color: #dee2e6 !important;
  background: #c3c3c3 !important;
}
:host ::ng-deep #as-grid tbody tr:has(.summary-row) td.column-mesReferencia{
  border-right-color: #dee2e6 !important;
}

/* Rótulo "Total:" na primeira coluna */
:host ::ng-deep #as-grid tbody tr:has(.summary-row) td.column-Municipio {
  border-top-color: #c3c3c3;
  border-right-color: #c3c3c3;
}

/* Totais nas colunas de valor */
:host ::ng-deep #as-grid tbody tr:has(.summary-row) td .total-cell {
  display: block;
  font-weight: 700;
  color: #111;
  /* opcional: tracejado de topo para demarcar */
  /* border-top: 1px solid #e1e4e8; */
  padding-top: .15rem;
}



    </style>


// WEBPACK FOOTER //
// ./src/app/royalts/cadastra-valor-mensal/consulta-valor-mensal/consulta-valor-mensal-municipio.component.html